import InvoiceAutomationRunScheduleEnum from './InvoiceAutomationRunScheduleEnum';

// When Bravo runs a setup, worded to be read inside the setup page's sentence "Bravo prepares this project's draft
// invoices …". The setup form's own labels are InvoiceAutomationRunScheduleOptionsArray.
const InvoiceAutomationRunScheduleSentenceOptionsArray = [
  { value: InvoiceAutomationRunScheduleEnum.Daily, label: 'automatically, every morning' },
  { value: InvoiceAutomationRunScheduleEnum.OnDemand, label: 'only when someone clicks Run Now' },
];

export default InvoiceAutomationRunScheduleSentenceOptionsArray;
